// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import "bootstrap";
require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");
require("chart.js");
var $ = require( 'jquery' );
window.$ = $
var JSZip = require('jszip');
window.JSZip = JSZip;
require('datatables.net');
require("datatables.net-fixedcolumns");
// require("datatables.net-bs4");
// require("datatables.net-fixedheader-dt");
// require("datatables.net-fixedheader-dt/css/fixedHeader.dataTables");
// require("datatables.net-fixedcolumns/css/fixedColumns.dataTables");
// require('datatables.net-dt')
require("datatables.net-buttons");
// require("datatables.net-buttons-dt");
require("datatables.net-buttons/js/buttons.html5")
require("select2")



const Calendar = require("tui-calendar");
const moment = require("moment");

const Popper = require("@popperjs/core");

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
const LEAVE_PROJECT_TYPE = "leave";
var tablereport = null;
var pmreport = null;
$(document).on("turbolinks:load", function () {
  $(".goto-form").on("change", 'input[type="date"], select ', function (event) {
    event.delegateTarget.submit();
  });

  const $leaveTypeInput = $(".leave-type-input");
  const $chargeCodeInput = $(".charge-code-input")
  const $projectSelect = $(".project-select-input")
  $('select[name="task[project_id]"]').on("change", function (event) {
    const projects = JSON.parse($("#data-projects").text());
    const selectedProject = projects.find(
      ({ id }) => id === +$(event.currentTarget).val()
    );
    if (selectedProject && selectedProject.project_type == LEAVE_PROJECT_TYPE) {
      $leaveTypeInput.removeClass("hidden");
    } else {
      $leaveTypeInput.find("select").prop("selectedIndex", 0);
      $leaveTypeInput.addClass("hidden");
    }
  });

  $('input[name="task[chargeable]"]').on("change", function (event) {
    if (event.currentTarget.checked) {
      $chargeCodeInput.removeClass("hidden");
      $projectSelect.addClass("hidden");
    } else {
      $chargeCodeInput.find("input").prop("value", null);
      $chargeCodeInput.addClass("hidden");
      $projectSelect.removeClass("hidden");
    }
  });


  $(".page-content-table").on("click", ".activity-detail", function (event) {
    $(this).toggleClass("expand");
  });

  hearts();

  $(".ranking-more-detail").on(
    "click",
    ".ranking-more-button",
    function (event) {
      $(".leaderboard-container, .ranking-description").toggleClass(
        "show-description"
      );
    }
  );

  if ($("#calendar").length) {
    const holidayColor = {
      Thailand: {
        borderColor: "#fa5420",
        bgColor: "#ff7f57",
        color: "#ffffff",
        location: "Thailand",
        raw: {
          icon: "thai-flags.svg",
        },
      },
      Vietnam: {
        borderColor: "#eb3d78",
        bgColor: "#ff669a",
        color: "#ffffff",
        location: "Vietnam",
        raw: {
          icon: "vn-flags.svg",
        },
      },
      Indonesia: {
        borderColor: "#5e5d2d",
        bgColor: "#982727",
        color: "#ffffff",
        location: "Indonesia",
        raw: {
          icon: "indo-flags.svg",
        },
      },
    };

    const holidays = JSON.parse($("#holidays-data").text()).map(
      ({ id, name, date, location }) => ({
        id,
        title: name,
        start: date,
        end: date,
        calendarId: "1",
        category: "allday",
        ...holidayColor[location.name],
      })
    );

    const leaveConfig = (type) => {
      switch (type) {
        case 2:
        case 6:
          return {
            icon: "sick-leave.svg",
            type: "Sick Leave",
          };
        case 3:
        case 7:
          return {
            icon: "business-leave.svg",
            type: "Business Leave",
          };
        case null:
        case 1:
        case 5:
          return {
            icon: "annual-leave.svg",
            type: "Annual Leave",
          };
        case 4:
        case 8:
          return {
            icon: "annual-leave.svg",
            type: "Leave Without Pay",
          };
        case 11:
        case 17:
          return {
            icon: "vaccine-leave.svg",
            type: "Special Business Leave (vaccine)",
          };

        case 9:
        case 10:
        case 16:
          return {
            icon: "Love_Heart_SVG.svg",
            type: "Maternity Leave",
          };

        default:
          return {
            icon: "close.png",
            type: "Need to change FE code",
          };
      }
    };

    const leaves = JSON.parse($("#leaves-data").text()).map(
      ({ id, date, leave_type_id, user, ...rest }) => ({
        id,
        title: user.name,
        start: date,
        end: date,
        calendarId: "1",
        category: "time",
        borderColor: "#8D6E63",
        body: rest.name,
        state: leaveConfig(leave_type_id) && leaveConfig(leave_type_id).type,
        raw: {
          hours: rest.hours,
          ...leaveConfig(leave_type_id),
        },
      })
    );

    const calendar = new Calendar("#calendar", {
      defaultView: "month",
      isReadOnly: true,
      useDetailPopup: true,
      template: {
        allday: function (schedule) {
          return `<img class="schedule-image" src="assets/${schedule.raw && schedule.raw.icon}"/><span class="schedule-title">${schedule.title}</span>`;
        },
        time: function (schedule) {
          return `<img class="schedule-image" src="assets/${schedule.raw && schedule.raw.icon}"/><span class="schedule-title leave">${schedule.title}</span>`;
        },
        popupDetailDate: function (isAllDay, start, end) {
          // var isSameDate = moment(start).isSame(end);
          // var endFormat = (isSameDate ? '' : 'YYYY.MM.DD') // + 'hh:mm a';

          // if (isAllDay) {
          //   return moment(start).format('YYYY.MM.DD') + (isSameDate ? '' : ' - ' + moment(end).format('YYYY.MM.DD'));
          // }

          return (
            moment(start).format("YYYY.MM.DD") +
            " - " +
            moment(end).format("YYYY.MM.DD")
          );
        },
        popupDetailState: function (schedule) {
          return `<img class="tui-full-calendar-icon schedule-icon-detail" src="assets/date.svg"/><span>${schedule.state} (${schedule.raw.hours} hrs)</span>`;
        },
        popupDetailBody: function (schedule) {
          return `<img class="tui-full-calendar-icon schedule-icon-detail" src="assets/bubble-speech.svg"/><span>${schedule.body}</span>`;
        },
      },
    });

    calendar.createSchedules([...holidays, ...leaves]);

    const getCalendarTitle = () => {
      const date = moment([
        calendar.getDate().getFullYear(),
        calendar.getDate().getMonth(),
        calendar.getDate().getDate(),
      ]);
      return date.format("MMMM YYYY");
    };

    $("#calendar-panel")
      .on("click", "#calendar-next", () => {
        calendar.next();
        $("#calendar-title").text(getCalendarTitle());
      })
      .on("click", "#calendar-prev", () => {
        calendar.prev();
        $("#calendar-title").text(getCalendarTitle());
      })
      .on("click", "#calendar-today", () => {
        calendar.today();
        $("#calendar-title").text(getCalendarTitle());
      });

    $("#calendar-title").text(getCalendarTitle());
  }

  $("#hamberger").on("click", function (event) {
    if ($("#left-bar").is(":visible")) {
      $("#left-bar").hide();
    } else {
      $("#left-bar").show();
    }
  });

  $("#arrow-up").on("click", function (event) {
    if ($(".minus-content").is(":visible")) {
      $(".minus-content").hide();
      $(this).html("&#x2796;");
    } else {
      $(".minus-content").show();
      $(this).html("&#10005;");
    }
  });
  if ($("#lm-report-table_wrapper").length == 0) {
    table_report();
  }
  if ($("#pm-report-table_wrapper").length == 0) {
    pm_report_table();
  }
  if ($("#default-table_wrapper").length == 0) {
    default_table_table();
  }
  $("#pm-chart-contain").hide();
  $("#chart-button").on("click", function (event) {
    if ($("#pm-table-contain").is(":visible")) {
      $("#pm-table-contain").hide();
      $("#pm-chart-contain").show();
    } else {
      $("#pm-table-contain").show();
      $("#pm-chart-contain").hide();
    }
  });

  $("#export").on("click", function () {
    var start_date = $("#export_form").find('input[name="start_date"]').val();
    var end_date = $("#export_form").find('input[name="end_date"]').val();
    var location_id = $("#export_form")
      .find('select[name="location_id"]')
      .val();
    if ($("#report_is_export").text() == "F") {
      $("#export_modal").modal("show");
    } else {
      window.location.href =
        "/lm_detail_reports/export.xlsx?start_date=" +
        start_date +
        "&end_date=" +
        end_date +
        "&location_id=" +
        location_id;
    }
  });
  const tooltip = document.querySelector('#task-tooltip');
  const scrollTable = document.querySelector('#lm-report-table_wrapper .dataTables_scrollBody')
  
  if (scrollTable && tooltip) {
      scrollTable.addEventListener('scroll', ()=>{
        tooltip.style.display = "none";
    })
  }

  // var e = ('ontouchstart' in window) ? 'click' : 'mouseenter';

 function showTaskTooltip(button, tooltip) {
  Popper.createPopper(button, tooltip, {
            placement: 'left',
            // strategy: 'fixed',
            modifiers: [
              {

                options: {
                  offset: [0, 5],
                },

              },
              {
                name: 'flip',
                options: {
                  fallbackPlacements: ['right'],
                },
              }
            ],
          });
  tooltip.style.display = "block";
 }

  $(".reveal-tasks").on("click", function () {
    
    var button = this
    $.ajax({
      url: "/tasks",
      type: "get",
      dataType: "json",      
      data: {
        user_id: $(this).attr("user_id"),
        date: $(this).attr("date")
      },
        success: function(response) {
          var tasks = response.tasks
          if (tasks.length > 0) {
            var lis = tasks.map(t=>`<li>${t.projectname} - ${t.taskname? t.taskname: '[Not given]'}: ${t.hours}h </li>`).reduce((acc,li)=>acc + li, '')
            $('#task-tooltip').html(`<ul classname='task-list'>${lis}</ul>`)
            showTaskTooltip(button, tooltip)
          }

        },
        error: function(xhr) {
          $('#task-tooltip').html(`${xhr.responseText}`)
          showTaskTooltip(button, tooltip)
      }
    });
  });

  create_chart();

  $("#prefix").on("change", function () {
    var projects = JSON.parse($("#projects-value").text());
    var projects_result = null;
    if (!this.value) {
      projects_result = projects;
    } else {
      projects_result = projects.filter(
        (project) => project.name.indexOf(this.value) > -1
      );
    }

    var ele_project = $("#project_id");
    ele_project.empty();
    ele_project.append(
      $("<option></option>").attr("value", "").text("Select Project")
    );
    projects_result.forEach((val, index) => {
      ele_project.append(
        $("<option></option>").attr("value", val.id).text(val.name)
      );
    });
  });

  dashboard_calendar();

  user_report();
});

$.rnd = function (m, n) {
  m = parseInt(m);
  n = parseInt(n);
  return Math.floor(Math.random() * (n - m + 1)) + m;
};

// credit: https://codepen.io/z-/pen/bpxgWZ
function hearts() {
  $.each($(".particletext.hearts"), function () {
    var heartcount = ($(this).width() / 150) * 5;
    for (var i = 0; i <= heartcount; i++) {
      var size = $.rnd(60, 120) / 10;
      $(this).append(
        '<span class="particle" style="top:' +
          $.rnd(20, 80) +
          "%; left:" +
          $.rnd(0, 95) +
          "%;width:" +
          size +
          "px; height:" +
          size +
          "px;animation-delay: " +
          $.rnd(0, 30) / 10 +
          's;"></span>'
      );
    }
  });
}
function default_table_table() {
  $("#default-table").DataTable({
    searching: false,
    pageLength: 1000,
    scrollX: true,
    scrollY: true,
    lengthChange: false,

  });
}

function pm_report_table() {
  pmreport = $("#pm-report-table").DataTable({
    dom: 'Bfrtip',
    buttons: [
            'copyHtml5',
            'excelHtml5',
            'csvHtml5',
    ],
    searching: false,
    pageLength: -1,
    scrollY: 400,
    scrollX: true,
    scrollCollapse: true,
    fixedHeader: true,
    fixedColumns: {
      leftColumns: 2,
    },
    paging: false,
  });
}
function table_report() {
  tablereport = $("#lm-report-table").DataTable({
    dom: 'Bfrtip',
    buttons: [
            'copyHtml5',
            'excelHtml5',
            'csvHtml5',
    ],
    ordering: false,
    searching: false,
    pageLength: -1,
    scrollY: 400,
    scrollX: true,
    scrollCollapse: true,
    fixedHeader: true,
    fixedColumns: {
      leftColumns: 5,
    },
    paging: false,
    // lengthMenu: [
      // [10, 25, 50, 100, -1],
      // ["10", "25", "50", "100", "Show all"],
    // ],

  });
}
$(document).ready(function () {
  table_report;
  // pm_report_table()
  $('.project-select').select2();
});

function create_chart() {
  var labels = [];
  var departments = [];
  var datasets = [];
  var project_val = null;
  var hours = null;
  var chart_data = $("#pm-chart-data").text();
  if (chart_data) {
    var hours_data = JSON.parse(chart_data);

    hours_data.forEach((val, index) => {
      labels.push(val.name);
    });

    JSON.parse($("#pm-chart-departments").text()).forEach((val, index) => {
      hours = [];
      hours_data.forEach((i_data, index) => {
        hours.push(i_data[val.abbreviation] ? i_data[val.abbreviation] / 8 : 0);
      });
      project_val = {
        label: val.abbreviation,
        backgroundColor: getRandomColor(),
        data: hours,
      };
      datasets.push(project_val);
    });
    var ctx = $("#pmChart");
    var pm_char = new Chart(ctx, {
      type: "bar",
      data: {
        labels: labels,
        datasets: datasets,
      },
    });
  }
}

function getRandomColor() {
  var letters = "0123456789ABCDEF".split("");
  var color = "#";
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

function dashboard_calendar() {
  if ($("#dashboard-calendar").length) {
    const holidayColor = {
      Thailand: {
        borderColor: "#fa5420",
        bgColor: "#ff7f57",
        color: "#ffffff",
        location: "Thailand",
        raw: {
          icon: "thai-flags.svg",
        },
      },
      Vietnam: {
        borderColor: "#eb3d78",
        bgColor: "#ff669a",
        color: "#ffffff",
        location: "Vietnam",
        raw: {
          icon: "vn-flags.svg",
        },
      },
    };
    var tasks_path = $("#tasks_path").text();
    var hours = JSON.parse($("#hours-data").text()).filter(
      (val) =>
        JSON.parse($("#holidays-data").text()).findIndex(
          (i) => i.date == val.date
        ) < 0
    );
    const lessthan6 = hours.map((val, index) => ({
      id: index,
      title: "Less than 6 hours.",
      start: val["date"],
      end: val["date"],
      calendarId: "1",
      category: "allday",
      borderColor: "#f16674",
      bgColor: "#f896a0",
      color: "#000000",
    }));

    const holidays = JSON.parse($("#holidays-data").text()).map(
      ({ id, name, date, location }) => ({
        id,
        title: name,
        start: date,
        end: date,
        calendarId: "1",
        category: "allday",
        ...holidayColor[location.name],
      })
    );

    const calendar = new Calendar("#dashboard-calendar", {
      defaultView: "month",
      isReadOnly: true,
      useDetailPopup: false,
      template: {
        allday: function (schedule) {
          if (schedule.title === "Less than 6 hours.") {
            return `<a href="${
              tasks_path +
              "?date=" +
              moment(schedule.start._date).format("YYYY-MM-DD")
            }" class="schedule-title" style="color:#000000">${
              schedule.title
            }</a>`;
          }
          if (!schedule.raw) {
            return `<span class="schedule-title">${schedule.title}</span>`;
          }
          return `<img class="schedule-image" src="assets/${schedule.raw.icon}" style="width:20px"/><span class="schedule-title">${schedule.title}</span>`;
        },
        time: function (schedule) {
          if (schedule.title === "Less than 6 hours.") {
            return `<a href="${
              tasks_path +
              "?date=" +
              moment(schedule.start._date).format("YYYY-MM-DD")
            }" class="schedule-title" style="color:#000000">${
              schedule.title
            }</a>`;
          }
          if (!schedule.raw) {
            return `<span class="schedule-title">${schedule.title}</span>`;
          }
          return `<img class="schedule-image" src="assets/${schedule.raw.icon}"/><span class="schedule-title leave">${schedule.title}</span>`;
        },

        popupDetailState: function (schedule) {
          return `<img class="tui-full-calendar-icon schedule-icon-detail" src="assets/date.svg"/><span>${schedule.state} (${schedule.raw.hours} hrs)</span>`;
        },
        popupDetailBody: function (schedule) {
          return `<img class="tui-full-calendar-icon schedule-icon-detail" src="assets/bubble-speech.svg"/><span>${schedule.body}</span>`;
        },
      },
    });

    calendar.createSchedules([...holidays, ...lessthan6]);

    const getCalendarTitle = () => {
      const date = moment([
        calendar.getDate().getFullYear(),
        calendar.getDate().getMonth(),
        calendar.getDate().getDate(),
      ]);
      return date.format("MMMM YYYY");
    };

    $("#dashboard-calendar-panel")
      .on("click", "#calendar-next", () => {
        calendar.next();
        $("#calendar-title").text(getCalendarTitle());
      })
      .on("click", "#calendar-prev", () => {
        calendar.prev();
        $("#calendar-title").text(getCalendarTitle());
      })
      .on("click", "#calendar-today", () => {
        calendar.today();
        $("#calendar-title").text(getCalendarTitle());
      });

    $("#calendar-title").text(getCalendarTitle());
  }
}

function user_report() {
  var selected_leave_type_id = $("#selected-leave-type-id").text();

  var ele_leave = $('#user-report select[name="leave_type_id"]');
  ele_leave.append(
    $("<option></option>")
      .attr("value", 99)
      .text("Annual Leave(auto fill leave)")
  );
  if (selected_leave_type_id == "99") {
    ele_leave.prop("selected", true);
  }

  $('#user-report select[name="location_id"]').on("change", function (event) {
    var location_id = $(event.currentTarget).val();
    var leave_type_list = JSON.parse($("#leave-type-all").text()).filter(
      (leave) => leave.location_id == location_id
    );

    ele_leave.empty();
    ele_leave.append(
      $("<option></option>").attr("value", "").text("Select leave type")
    );
    leave_type_list.forEach((val, index) => {
      ele_leave.append(
        $("<option></option>").attr("value", val.id).text(val.name)
      );
    });
    ele_leave.append(
      $("<option></option>")
        .attr("value", 99)
        .text("Annual Leave(auto fill leave)")
    );
  });

  $("#user-report-table").DataTable({
    searching: true,
    pageLength: -1,
    scrollY: 400,
    scrollX: true,
    scrollCollapse: true,
    fixedHeader: true,
    lengthMenu: [
      [10, 25, 50, 100, -1],
      ["10", "25", "50", "100", "Show all"],
    ],
  });
}
